import React from 'react';
import { navLinks } from '../data/navLinks';
interface FooterProps {
  onOpenWaitlist: () => void;
}
export const Footer: React.FC<FooterProps> = ({
  onOpenWaitlist
}) => {
  return <footer className="border-t border-white/10 bg-deep-juniper py-12 text-sandstone" data-id="element-62" data-mp="32o4ao9g4a660">
      <div className="section-container" data-id="element-63" data-mp="36pft9v0kpr4p">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-64" data-mp="36qhg0wqyc229">
          <div data-id="element-65" data-mp="3ug3etj3ewf9q">
            <a href="#top" className="rounded-md font-literata text-2xl font-medium text-white focus-visible:ring-offset-deep-juniper focus-visible:ring-white" aria-label="Re:Joy home" data-id="element-66" data-mp="3ugbpd4c2b8hr">
              Re:<span className="text-rejoy-coral" data-id="element-67" data-mp="3qdf2v2jeis8j">Joy</span>
            </a>
            <p className="mt-2 text-sandstone/80" data-id="element-68" data-mp="3qblzbw434o4r">
              Therapist-led group care, in development.
            </p>
          </div>
          <nav aria-label="Footer" data-id="element-69" data-mp="2ey05hxna5ycw">
            <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-70" data-mp="2ez1joazlf0yu">
              {navLinks.map(link => <li key={link.href} data-id="element-71" data-mp="3la2akxul99wt">
                  <a href={link.href} className="rounded-md hover:text-white hover:underline underline-offset-4 focus-visible:ring-white focus-visible:ring-offset-deep-juniper" data-id="element-72" data-mp="3lbdb8osqm1jp">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-73" data-mp="82ihs7hrf0lp">
                <button type="button" onClick={onOpenWaitlist} className="rounded-md hover:text-white hover:underline underline-offset-4 focus-visible:ring-white focus-visible:ring-offset-deep-juniper" data-id="element-74" data-mp="81yyamcgo45k">
                  Join the waitlist
                </button>
              </li>
            </ul>
          </nav>
        </div>
        <p className="mt-10 border-t border-sandstone/20 pt-6 text-sm text-sandstone/70" data-id="element-75" data-mp="qujkjkxnnb0e">
          © 2026 Re:Joy Health. All rights reserved.
        </p>
      </div>
    </footer>;
};